import React, { useEffect, useState } from "react";
import CrudTable from "../components/CrudTable";
import { api } from "../lib/api";

const columns = [
  { key: "serial_number", label: "Serial", render: (v, r) => <a href={`/assets/${r.id}`} className="text-blue-600 hover:underline font-mono">{v}</a> },
  { key: "model", label: "Model" },
  { key: "capacity_kw", label: "Capacity (kW)" },
  { key: "health", label: "Health %" },
  { key: "manufacturer_device_id", label: "IoT", render: (v) => v ? <span className="inline-flex items-center gap-1 text-xs text-emerald-500"><span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" /> #{v}</span> : <span className="text-xs text-muted-foreground">—</span> },
  { key: "outlet_id", label: "Outlet", render: (v) => v ? v.slice(0, 8) + "…" : "-" },
  { key: "status", label: "Status", status: true },
];

export default function Assets() {
  const [mfrs, setMfrs] = useState([]);
  useEffect(() => { api.get("/manufacturers", { params: { limit: 200 } }).then((r) => setMfrs(r.data.items)); }, []);
  const formFields = [
    { name: "serial_number", label: "Serial Number", required: true },
    { name: "manufacturer_id", label: "Manufacturer", type: "select", required: true, options: mfrs.map((m) => ({ value: m.id, label: m.name })) },
    { name: "model", label: "Model", default: "FlexiPod 5.5" },
    { name: "capacity_kw", label: "Capacity (kW)", type: "number", default: 5.5 },
    { name: "voltage", label: "Voltage", type: "number", default: 48 },
    { name: "warranty_start", label: "Warranty Start", type: "date" },
    { name: "warranty_end", label: "Warranty End", type: "date" },
    { name: "health", label: "Health %", type: "number", default: 100 },
    { name: "status", label: "Status", type: "select", default: "in_inventory",
      options: [
        { value: "in_inventory", label: "In inventory" },
        { value: "allocated", label: "Allocated" },
        { value: "installed", label: "Installed" },
        { value: "maintenance", label: "Maintenance" },
        { value: "retired", label: "Retired" },
      ] },
    { name: "remarks", label: "Remarks", wide: true },
  ];
  return <CrudTable title="Assets" description="Track every FlexiPod battery from inventory to retirement." endpoint="/assets" columns={columns} formFields={formFields} />;
}
